import styled from 'styled-components';

interface IContainerProps {
  showSidebar: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: 140px;
  min-width: 140px;
  height: 100vh;
  min-height: 100%;
  background-color: ${({ theme }) => theme.colors.background.white};
  border-right: 1px solid #cccbcc;
  z-index: 11;

  position: ${(props) => (props.showSidebar ? 'sticky' : 'fixed')};
  top: 0;

  left: ${(props) => (props.showSidebar ? '-140' : '0')};
  transform: translate(${(props) => (props.showSidebar ? '0px' : '-140px')});

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.gray[500]};
    font-weight: 800;
  }

  ul {
    list-style: none;
  }

  aside {
    position: absolute;
    bottom: 88px;
    left: 16%;
    width: 96px;

    .logout-button:hover {
      background-color: ${({ theme }) => theme.colors.gray[100]};
    }

    bottom {
      width: 100%;
    }

    img {
      width: 100%;
    }
  }
`;

export const LinkHome = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: none;
  border: none;

  img {
    margin: 32px 0px;
    width: 80%;

    max-width: 104px;
    max-height: fit-content;
  }
`;

export const ButtonHideSidebar = styled.button<IContainerProps>`
  position: absolute;
  width: 30px;
  height: 30px;
  top: 28px;
  right: ${(props) => (props.showSidebar ? '-15px' : '-45px')};
  background-color: ${({ theme }) => theme.colors.background.white};
  border: 1px solid #cccbcc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 99;
  transition: all 0.2s ease-in-out;
  outline: none;

  svg {
    color: ${({ theme }) => theme.colors.gray[500]};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray[500]};
    transform: scale(1.1);

    svg {
      color: ${({ theme }) => theme.colors.background.white};
    }
  }
`;
